<template>
  <b-card class="card-profile">
    <h3>{{ cohortData.name }}</h3>
    <hr class="mb-1" />

    <div class="price-details">
      <ul class="list-unstyled">
        <li class="price-detail">
          <div class="detail-title">Status</div>
          <div class="detail-amt">
            {{ title(cohortData.status) }}
          </div>
        </li>
        <li class="price-detail">
          <div class="detail-title">Expires At</div>
          <div v-if="cohortData.expiresAt" class="detail-amt discount-amt">
            {{ moment(cohortData.expiresAt).format('hh:mm A L') }}
          </div>
          <div v-else class="detail-amt discount-amt text-danger">Non-Expiring</div>
        </li>
        <li class="price-detail">
          <div class="detail-title">Password Protected</div>
          <div v-if="!cohortData.password" class="detail-amt discount-amt text-danger">No</div>
          <div v-else class="detail-amt discount-amt">
            <span class="text-success">Yes</span>
            &nbsp;
            <b-button @click="copyCohortPassword" variant="primary" size="sm" style="padding: 3px; text-align: center">
              <feather-icon icon="ClipboardIcon"></feather-icon>
            </b-button>
          </div>
        </li>
        <li class="price-detail">
          <div class="detail-title">Total Profiles</div>
          <div class="detail-amt discount-amt">
            {{ cohortData.profiles.length }}
          </div>
        </li>
      </ul>

      <hr />

      <b-button
        :to="{ name: 'apps-placement-cohort-edit', params: { id: cohortData.id } }"
        variant="primary"
        size="sm"
        block
      >
        Edit Cohort
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol, BBadge } from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import useCohortsList from '../cohort-list/useCohortList';
import { title } from '@core/utils/filter';
import usAppConfig from '@core/app-config/useAppConfig';
import moment from 'moment';

const { skin } = usAppConfig();

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BBadge,
  },
  props: {
    cohortData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    copyCohortPassword() {
      console.log(`copying cohort password`);
      this.$copyText(
        `https://recruiters.intellectualpoint.com/cohorts/${this.cohortData.id}?code=${btoa(this.cohortData.password)}`
      )
        .then((a) => {
          console.log(`copied`, a);
        })
        .catch((e) => console.error(e));
    },
  },
  setup() {
    const { resolveCohortStatusVariant } = useCohortsList();
    return {
      avatarText,
      resolveCohortStatusVariant,
      title,
      skin,
      moment,
    };
  },
};
</script>

<style scoped lang="scss">
$card-spacer-y: 0.75rem !default;

.card-profile {
  .card-body {
    position: relative;
    padding: 1.5rem 1rem $card-spacer-y 1rem !important;
  }
}

.price-details {
  .price-title {
    font-weight: 600 !important;
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
  }

  .price-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;

    .detail-title {
      &.detail-total {
        font-weight: bolder !important;
      }
    }
  }
}
</style>
